/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './InstructionText.style';

type Props = {
  layoutClass?: string,
  withError?: boolean,
  children?: React.Node,
  left?: boolean,
  // Self passed
};

const useStyles = createUseStyles(styles);

const InstructionText = ({
  layoutClass,
  withError,
  left,
  children,
}: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes

  const rootClasses = classNames(classes.root, layoutClass, {
    [`${classes['root-withError']}`]: withError,
    [`${classes['root-left']}`]: left,
  });

  return <p className={rootClasses}>{children}</p>;
};

export default InstructionText;
